'use strict';

function CnPdfExportController($location) {
  var vm = this;

  vm.$onInit = $onInit;

  function $onInit() {
    vm.exportUrl = encodeURIComponent($location.absUrl());
  }
}

module.exports = CnPdfExportController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-pdf-export/cn-pdf-export.controller.js
 ** module id = 55
 ** module chunks = 0
 **/